<template>
  <div>
    <template v-if="company">
      <Company />
    </template>
  </div>
</template>

<script lang="ts">
import Company from '~/components/Company.vue'
import { useCompanyStore } from '~/store/company'

export default {
  components: {
    Company
  },
  setup () {
    const companyStore = useCompanyStore()

    return {
      company: computed(() => companyStore.company)
    }
  }
}
</script>

<style scoped>

</style>
